import { LoggerFactory } from "@infobis/as-logger";

export default LoggerFactory

